module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Estes Park Colorado")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("I am thankful to those who preserve local history, especially local history librarian Lennie Bemiss, who walked into the Estes Park Library in 1972 and asked my aunt, librarian Ruth Deffenbaugh, if she could volunteer. Without Lennie’s pioneering local history work, I would not have access to a treasure trove of oral histories and a partial index to the "), _c('i', [_vm._v("Estes Park Trail-Gazette")]), _vm._v(". Also, a big thanks goes to author James Pickering, who wrote so many excellent local histories, and Ted Schmidt for his Colorado–Big Thompson Project slide show and Ray Fitch video.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This book would not be possible without area museums and the Estes Valley Library. At the Estes Park Museum, thank you Derek Fortini for looking over my list and Bryon Hoerner, Alicia Mittleman, and Naomi Gerakios for digging out all those photographs. Carie Essig at the YMCA of the Rockies Lula W. Dorsey Museum and Kelly Cahill at the Rocky Mountain National Park Museum Storage Facility were super in responding to my relentless requests for pictures. Kathleen Kase, Mark Riffle, and Keturah Young at the Estes Valley Library were very patient with my endless requests to see the archives. Thank you to Shannon Clark at MacGregor Ranch for the great MacGregor photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many generous people shared their Estes Park stories and pictures. Thank you to all who I interviewed and featured in the book, as well as Diane Rayburn, Jackie Hutchins, Kurtis Kelly, Debbie Richardson, Teddie Haines, Pat Washburn, Kim Stevens, Rosa Thomson, Rita Mayhew, Katie Webermeier, Jack Melton, Sybil Barnes, Brian Brown, John Meissner, Fran and Jay Grooters, Howell Wright, Kerrie Hill, Dave Tanton, Elah Bethel, Bonnie Watson, Ken Springsteen, Ann Neering, Gerald Mayo, Scott and Julie Roederer, John Cordsen, and Lois Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I want to thank photographers James Frank, Tony Bielat, Heidi Wagner, Emily Rogers, and Kris and Gary Hazelton for sharing their work. And a special thanks to my wife, Lori Mitchell, who seems to know everyone in town and how they are related to each other.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 78
// module chunks = 0